import { FormattedMessage } from 'react-intl';

import { useExternalLinks } from '@/app/hooks/useExternalLinks';

import s from './styles.module.css';

const ChangeEmailTip = () => {
  const links = useExternalLinks();

  return (
    <span className={s.changeEmailTip}>
      <FormattedMessage
        defaultMessage="Contact <a>Operations Team</a> ({link}) to edit your email."
        id="MiG9LY"
        values={{
          a: (text: React.ReactNode) => (
            <a href={`mailto:${links.contactOperationTeam}`} target="_blank" rel="noreferrer">
              {text}
            </a>
          ),
          link: links.contactOperationTeam,
        }}
        description="Profile screen"
      />
    </span>
  );
};

export { ChangeEmailTip };
